import { render, staticRenderFns } from "./flyerSection.component.vue?vue&type=template&id=157e2406&scoped=true"
import script from "./flyerSection.component.vue?vue&type=script&lang=js"
export * from "./flyerSection.component.vue?vue&type=script&lang=js"
import style0 from "./flyerSection.component.vue?vue&type=style&index=0&id=157e2406&prod&lang=scss"
import style1 from "./flyerSection.component.vue?vue&type=style&index=1&id=157e2406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e2406",
  null
  
)

export default component.exports